module.exports = __webpack_public_path__ + "static/media/tenge.a5d03a50.svg";